import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import List from "@/Pages/Reports/Expenses/List.vue";
let Office = class Office extends Vue {
    user;
    dates;
    branchesId;
    extendQuery = { staffId: null };
};
__decorate([
    Prop(Array)
], Office.prototype, "user", void 0);
__decorate([
    Prop(Object)
], Office.prototype, "dates", void 0);
__decorate([
    Prop(Array)
], Office.prototype, "branchesId", void 0);
Office = __decorate([
    Component({
        components: { List },
    })
], Office);
export default Office;
